import { Style1 } from './style1';
import { Style2 } from './style2';
import { Style3 } from './style3';
import { Style4 } from './style4';
import { Style5 } from './style5';
import { Style6 } from './style6';
import { Style7 } from './style7';
import { Style8 } from './style8';
import { Style9 } from './style9';
import { Style10 } from './style10';
import { Style11 } from './style11';
import { Style12 } from './style12';
import { Style13 } from './style13';
import { Style14 } from './style14';
import { Style15 } from './style15';
import { Style16 } from './style16';
import { Style17 } from './style17';
import { Style18 } from './style18';
import { Style19 } from './style19';
import { Style20 } from './style20';
import { Style21 } from './style21';
import { Style22 } from './style22';

export const styles = {
  style1: Style1,
  style2: Style2,
  style3: Style3,
  style4: Style4,
  style5: Style5,
  style6: Style6,
  style7: Style7,
  style8: Style8,
  style9: Style9,
  style10: Style10,
  style11: Style11,
  style12: Style12,
  style13: Style13,
  style14: Style14,
  style15: Style15,
  style16: Style16,
  style17: Style17,
  style18: Style18,
  style19: Style19,
  style20: Style20,
  style21: Style21,
  style22: Style22
};
